<template>
    <v-app id="app">
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer"/>
            <v-toolbar-title>
                {{ `${ $route.meta.title }` | t }}
            </v-toolbar-title>
            <v-combobox
                    v-if="hasPermissionForAction(PermissionsConstants.SHIPMENT, PermissionsConstants.SEARCH)"
                    :items="searchHistory"
                    :value="searchShipmentString"
                    @input="controlSearchString($event)"
                    item-text="keyword"
                    id="searchInput"
                    class="mt-6 mx-2"
                    :placeholder="t('Shipment name...')"
                    prepend-inner-icon="search"
                    flat
                    solo
                    dense
                    clearable
            >
                <template slot="item" slot-scope="data">
                    <span
                            @click="updateShipmentSearchOnClick(data.item.keyword)"
                            style="width: 100%; height: 100%"
                            class="pa-2"
                    >{{ data.item.keyword }}</span>
                </template>
            </v-combobox>
            <v-menu offset-y bottom left
                                 v-if="hasPermissionForAction(PermissionsConstants.SHIPMENT, PermissionsConstants.CREATE)">
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleGenerateLinkClick">
                        <v-list-item-title>{{ "Generate link for client" | t }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="openNewShipmentDrawer">
                        <v-list-item-title>{{ "Create" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen"/>

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900" style="z-index: 205">
            <shipment-view v-if="$route.name == 'shipment-view'"></shipment-view>
            <shipment-edit v-if="$route.name == 'shipment-edit'"></shipment-edit>
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <router-view/>
        </v-main>

        <generate-link-dialog></generate-link-dialog>

        <!-- Footer -->
        <page-footer/>

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ errorMessage || 'Errors' | t }}</div>
            </div>
        </v-snackbar>

    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import ShipmentView from "../pages/shipment/shipment-view.vue";
import ShipmentEdit from "../pages/shipment/shipment-edit.vue";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../store";
import { PermissionsConstants } from "@/permissions";
import GenerateLinkDialog from "@/pages/shipment/dialog/generate-link-dialog.vue";

export default {
    components: {
        ShipmentView,
        ShipmentEdit,
        PageFooter,
        MainDrawer,
        GenerateLinkDialog
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async created() {
        await this.getSearchHistory(this.$route.path.replace("/", ""))
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    destroyed() {
        if (this.searchShipmentString.length > 0) this.resetShipmentSearch();
        document.removeEventListener("keydown", this.handleKeyboardListener);
        this.setRequestSuccess(false)
        this.setErrorMessage("")
    },
    methods: {
        ...mapMutations("ShipmentStore", ["resetActiveShipment", "setShipmentSearch", "setRequestSuccess", "setErrorMessage", "resetShipmentSearch", "setGenerateLinkDialog"]),
        ...mapActions("SearchHistoryStore", ["getSearchHistory"]),
        openNewShipmentDrawer() {
            this.$router.push({ name: "shipment-edit", params: { shipmentId: "new" } });
        },
        handleGenerateLinkClick(){
            this.setGenerateLinkDialog(true)
        },
        updateShipmentSearch(value) {
            this.setShipmentSearch({ term: value })
            this.setRequestSuccess(false)
            this.setErrorMessage("")
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                this.resetActiveShipment();
                this.$router.push({ name: "shipment-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                Store.commit("ShipmentStore/updateShipmentSearch", {
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                    this.activeShipment &&
                    Object.keys(this.activeShipment).length > 0 &&
                    this.activeShipment.id !== "new" &&
                    this.$route.name !== "shipment-edit"
            ) {
                let currentShipmentIndex = this.shipments[this.activeShipment.direction].findIndex(p => p.id === this.activeShipment.id);
                if (e.key === "ArrowUp") {
                    if (currentShipmentIndex !== 0) {
                        const newShipmentId = this.shipments[this.activeShipment.direction][currentShipmentIndex - 1].id;
                        Store.dispatch("ShipmentStore/getShipmentData", newShipmentId);
                        this.$router.push({ name: this.$route.name, params: { shipmentId: newShipmentId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentShipmentIndex + 1 !== this.shipments[this.activeShipment.direction].length) {
                        const newShipmentId = this.shipments[this.activeShipment.direction][currentShipmentIndex + 1].id;
                        Store.dispatch("ShipmentStore/getShipmentData", newShipmentId);
                        this.$router.push({ name: this.$route.name, params: { shipmentId: newShipmentId } });
                    }
                }
            }
        },
        async updateShipmentSearchOnClick(value) {
            await this.setShipmentSearch({ term: value })
        },
        controlSearchString(value) {
            if (value !== "") this.updateShipmentSearch(value);
        }
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("ShipmentStore", ["drawerOpen", "searchShipmentString", "requestSuccess", "requestError", "errorMessage", "shipments", "activeShipment", "generateLinkDialog"]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
